import { ApiRouts } from '@/lib/routes/routes';
import { TCart, TUpdateCart } from '@/types/carts';
import { BranchResponse } from '@/types/catalog';
import HttpCLient from '@/lib/utils/httpClient';

class CartServices extends HttpCLient {
  getAllCarts = async () => {
    return await this.get<TCart[]>(
      ApiRouts.allCarts,
      {},
      {
        next: {
          tags: ['carts'],
        },
      },
    );
  };

  getCartById = async (id: string) => {
    return await this.get<TCart>(ApiRouts.cartById(id));
  };

  addCart = async (data: TUpdateCart): Promise<TCart> => {
    return await this.post(ApiRouts.addProductToCart, data);
  };

  removeItem = async (cartId: number | string, itemId: string): Promise<TCart> => {
    return await this.delete(ApiRouts.removeProductFromCart(cartId, itemId));
  };

  removeCart = async (cartId: number | string) => {
    return await this.delete(ApiRouts.deleteCart(cartId));
  };

  updateCart = async (data: TUpdateCart) => {
    return await this.post<BranchResponse>(ApiRouts.updateProductCart, data);
  };
}

export const cartServices = new CartServices();
